import { passThroughAxios } from './passThrough.axios'

const BASE = 'configurations'

export default {
  investigate(configurationCode, { deliveryDate }) {
    return passThroughAxios.get(`${BASE}/${encodeURIComponent(configurationCode)}/investigate`, {
      params: { deliveryDate: deliveryDate || undefined },
    })
  },
}
